import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	id: "Layer_1",
	viewBox: "0 0 45 45",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2.5 18c-.7 0-1.2.6-1.2 1.2v25.7h2.5V19.2c0-.7-.6-1.2-1.2-1.2Zm40 0c-.7 0-1.2.6-1.2 1.2v25.7h2.5V19.2c0-.7-.6-1.2-1.2-1.2Z",
			className: "icon-fill-secondary"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.4 0C11.3 0 2.3 9 2.3 20.1s9 20.1 20.1 20.1 20.1-9 20.1-20.1S33.5 0 22.4 0Zm0 2.5c6.5 0 12.2 3.6 15.3 8.9H7.1c3-5.3 8.7-8.9 15.3-8.9Zm0 35.3c-6.5 0-12.2-3.6-15.3-8.9h30.6c-3 5.3-8.7 8.9-15.3 8.9Zm16.4-11.4H5.9c-.7-1.9-1.2-4-1.2-6.2s.4-4.3 1.2-6.2h32.9c.7 1.9 1.2 4 1.2 6.2s-.4 4.3-1.2 6.2Z",
			className: "icon-fill-primary"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.4 20.1c-.7 0-1.2.6-1.2 1.2v23.6h2.5V21.3c0-.7-.6-1.2-1.2-1.2ZM33.7 19c-.7 0-1.2.6-1.2 1.2v24.7H35V20.2c0-.7-.6-1.2-1.2-1.2Zm-22.6 0c-.7 0-1.2.6-1.2 1.2v24.7h2.5V20.2c0-.7-.6-1.2-1.2-1.2Z",
			className: "icon-fill-secondary"
		})
	]
});
export default SvgIcon;
